// actions
const SET = 'reservation/SET';
const SET_SELECTED = 'reservation/SET_SELECTED';
const SET_FILTERS = 'reservation/SET_FILTERS';
const SET_SELECTED_FILTERS = 'reservation/SET_SELECTED_FILTERS';
const SET_NEXT_TOKEN = 'reservation/SET_NEXT_TOKEN';

const DEFAULT_STATE = {
  listing: [],
  filters: [],
  selectedFilters: [],
  searchText: '',
  selected: '',
  nextToken: null,
  nextNextToken: undefined,
  previousTokens: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED_FILTERS:
      return Object.assign({}, state, { selectedFilters: action.listing });
    case SET_FILTERS:
      return Object.assign({}, state, { filters: action.filters });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setFilters = (filters: any[]) => ({ filters, type: SET_FILTERS });
export const setSelectedFilters = (listing: any[]) => ({
  listing,
  type: SET_SELECTED_FILTERS,
});

// Pagination
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });

